export default "__VITE_ASSET__DCXNvzAF__"